// extracted by mini-css-extract-plugin
export default {"title":"map_title__kMBo+","tooltip_wrapper":"map_tooltip_wrapper__0SHzw","tooltipText":"map_tooltipText__7djqE","showingAnim":"map_showingAnim__0TcCu"};